import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { notification } from '../component/hocs/notification';
import { useDispatch } from 'react-redux';
import { signIn } from './../component/redux/logged';
import axios from 'axios';
import { mainurl } from '../MainUrl';
import { Col, Row, Label, Input, Button, FormGroup } from 'reactstrap';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [org_id, setOrgId] = useState(1); // New state for organization ID
  const [rawMaterials, setRawMaterials] = useState([]);
  const [finishedProducts, setFinishedProducts] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  const user_login = 'admin';
  const user_pass = 'admin123';

  const login_handler = () => {
    if (userName === user_login && password === user_pass) {
      dispatch(
        signIn({
          login: true,
          userName: user_login,
          userId: 123,
          org_id: org_id, // Include the selected organization ID
          logData: '',
        })
      );

      setIsLoggedIn(true); // Mark as logged in
      fetchData(); // Fetch data after login

      navigate('/home');
      let notify = notification({ message: 'Login successful!', type: 'success' });
      notify();
    } else {
      let notify = notification({ message: 'Invalid login credentials!', type: 'error' });
      notify();
    }
  };

  const fetchData = async () => {
    try {
      // Fetch raw materials
      const rawResponse = await axios.get(`${mainurl}raw_list`);
      setRawMaterials(rawResponse.data.data);

      // Fetch finished products
      const productResponse = await axios.get(`${mainurl}product_list`);
      setFinishedProducts(productResponse.data.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  return (
    <Row className="d-flex justify-content-center align-items-center h-100 loginPage">
      <Col md={4} className="p-4 rounded" style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
        <Row>
          <Col md={12} className="text-center mb-4">
            <h2>Shiva Enterprises</h2>
          </Col>

          <Col md={12} className="mb-2">
            <FormGroup>
              <Label>User Name</Label>
              <Input
                type="text"
                bsSize="sm"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                required
              />
            </FormGroup>
          </Col>

          <Col md={12} className="mb-2">
            <FormGroup>
              <Label>Password</Label>
              <Input
                type="password"
                bsSize="sm"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </FormGroup>
          </Col>

          {/* New Dropdown for Organization */}
          <Col md={12} className="mb-2">
            <FormGroup>
              <Label>Organization</Label>
              <Input
                type="select"
                bsSize="sm"
                value={org_id}
                onChange={(e) => setOrgId(e.target.value)}
              >
                <option value="1">Shiva Enterprises</option>
                <option value="2">3AP</option>
              </Input>
            </FormGroup>
          </Col>

          <Col md={12} className="mb-3">
            <Button className="text-white" color="primary" block onClick={login_handler}>
              Login
            </Button>
          </Col>
        </Row>
      </Col>

      {isLoggedIn && (
        <Col md={8} className="mt-4">
          <Row>
            <Col md={6}>
              <h4>Raw Materials</h4>
              <ul>
                {rawMaterials.map((item, index) => (
                  <li key={index}>
                    {item.name} - {item.current_stock} {item.uom}
                  </li>
                ))}
              </ul>
            </Col>
            <Col md={6}>
              <h4>Finished Products</h4>
              <ul>
                {finishedProducts.map((item, index) => (
                  <li key={index}>
                    {item.name} - {item.current_stock} {item.uom}
                  </li>
                ))}
              </ul>
            </Col>
          </Row>
        </Col>
      )}
    </Row>
  );
};

export default Login;
